exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-text-field .v-text-field--enclosed .v-text-field__details[data-v-6617aea4]{margin-bottom:-25px!important;display:none!important}.pack-form-box[data-v-6617aea4]{border-radius:16px;border:1px solid #9b9b9b}", ""]);

// exports
